import { api, apiRequest } from './api';
import type { CreatePatientRequest, CreatePatientResponse } from '@/types/api';

/**
 * Users API Module
 * Handles user creation and user profile management
 */
export const usersAPI = {
  /**
   * Create a new patient (user + profile in one call)
   * POST /internal/users/create-patient/
   */
  createPatient: (data: CreatePatientRequest): Promise<CreatePatientResponse> => {
    return apiRequest(() => api.post('/internal/users/create-patient/', data));
  },
};

